<template>
	<div>
		<div class="title row">
			<div>
				<h1>Gestion des utilisateurs<i class="fa fa-refresh fa-spin" aria-hidden="true"></i></h1>
			</div>
		</div>

		<v-dialog/>

		<modal name="modal-confirm"
         :classes="['v--modal', 'modal-confirm']"
         :pivot-y="0.2"
         :width="400"
         :height="125">
			<div class="confirm-modal-content">
				<div class="modal-title">
					<h6>Voulez-vous désactiver l'utilisateur <b>{{this.name}}</b></h6>
				</div>
				<div class="modal-button">
					<button @click="$modal.hide('modal-confirm')">Annuler</button>
					<button @click="destroy">Confirmer</button>
				</div>
			</div>
		</modal>

		<div class="row main-wrap">
			<div class="col-md-6">
				<div class="onglet">
					<h3>Liste des utilisateurs</h3>
				</div>
				<div class="section-bg">
					<div class="create-btn">
						<button type="submit" class="green-btn create" v-on:click="clear">
							<i class="fa fa-user" aria-hid-den="true"></i>
							Créer un profil
						</button>
					</div>
					<table class="table table-striped table-bordered" data-filtering="false">
						<thead>
							<tr>
								<th data-toggle="true">
									Nom de l'utilisateur
								</th>
								<th>
									Poste
								</th>
								<th data-sortable="false" data-breakpoints="x-small medium">
									Mail
								</th>
							</tr>
						</thead>
						<tbody>
							<tr class="table-row" v-for="utilisateur in allUtilisateurs" v-on:click="fill(utilisateur,$event)" @click="disabled = 1">
								<td>{{ utilisateur.user.name }} {{ utilisateur.user.surename }}</td>
								<td>{{ utilisateur.role }}</td>
								<td>{{ utilisateur.user.email }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="col-md-6">
				<div class="onglet">
				  <h3>Profil d'utilisateur</h3>
				</div>
				<div class="section-bg default-form" v-if="display">
					<div>
						<div class="ligne"></div>
						<p>Créer, modifier ou supprimer un utilisateur</p>
						<div class="ligne"></div>
					</div>
				</div>
				<form v-else class="section-bg" autocomplete="off" v-on:submit="submitForm">
					<div class="row">
						<div class="form-group col-sm-4 col-md-4">
							<label for="name">Prénom</label>
							<input type="text" id="name" class="form-control" v-model="name" required>
						</div>
						<div class="form-group col-sm-4 col-md-4">
							<label for="surname">Nom</label>
							<input type="text" id="surname" class="form-control" v-model="surname" required>
						</div>
						<div class="form-group col-sm-4 col-md-4">
							<label for="type">Type d'accès</label>
							<select v-model="type">
								<option value="Choisir un type d'acces" selected disabled>Choisissez un type d'accès</option>
								<option v-for="t in types" v-bind:value="t.value">
									{{ t.text }}
								</option>
							</select>
						</div>
					</div>
					<div class="row">
						<div class="form-group col-sm-4 col-md-4">
							<label for="role">Poste</label>
							<select v-model="role">
								<option value = "Choisir un role" selected disabled>Choisissez un Poste</option>
								<option v-for="role in roles" v-bind:value="role.value">
									{{ role.text }}
								</option>
							</select>
						</div>
						<div class="form-group col-sm-4 col-md-4">
							<label for="password">Password</label>
							<input type="password" id="password" class="form-control" v-if="removeUser === ''" v-model="password">
							<input type="password" id="password" class="form-control" v-else-if="removeUser === true" v-model="password">
							<input type="password" id="password" class="form-control" v-else v-model="password" required>
						</div>
						<div class="form-group col-sm-4 col-md-4">
							<label for="email">E-mail</label>
							<input type="email" id="email" class="form-control" placeholder="gavin.belson@hooli.com" v-model="email" required>
						</div>
					</div>
					<div class="row">
						<div class="wrap col-sm-12">
							<div class="checkbox">
								<input id="check" type="checkbox" name="check" value="check" v-model="removeUser">
								<label for="check">Désactiver le profil</label>
							</div>
						</div>
					</div>
					<hr>
					<div class="form-group time-div">
						<input type="number" min="1" id="solde" class="form-control time-input" v-model="solde" :disabled="disabled == 1 ? true : false" required :class="{disabled : disabled}"/>
						<label for="solde">Solde du compte-temps</label>
						<span class="update" v-on:click="modify" v-if="disabled == true">Modifier</span>
						<span class="update" v-on:click="cancel_modify" v-if="disabled == false">Annuler</span>
					</div>
					<hr class="hr-text" data-content="clients assignés">
					<div class="row clients-assignes-titre">
						<div class="col-xs-8">Client</div>
						<div class="col-xs-4 text-center">Jours vendus</div>
					</div>
					<template v-for="client in allClients">
						<div class="row clients-assignes-content" v-key="utilisateurclient" v-for="utilisateurclient in client.utilisateur" v-if="utilisateur && utilisateur.id == utilisateurclient.id">
							<div class="col-xs-8">
								{{ client.user.name }}
							</div>
							<div class="col-xs-4 text-center">
								{{ client.utilisateur[utilisateur.id].temps.temps }}
							</div>
						</div>
					</template>
					<div class="submit-btn">
						<button type="submit" class="green-btn">Sauvegarder</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from '../js/app.js';
import users from '../js/users.js';
import active from '../js/active.js';
import footable from'../js/footable.js';

export default {
	data() {
		return {
			name: null,
			surname: null,
			solde:null,
			email: null,
			type: null,
			password: null,
			role: null,
			temps: null,
			removeUser: false,
			updateUser: true,
			createUser:false,
			disabled: 0,
			response: null,
			utilisateur: null,
			selected: 'Consultant',
			types: [
				{ text: 'Consultant', value: 'Consultant' },
				{ text: 'Gestionnaires', value: 'admin' }
			],
			roles: [
				{text:'Directeur général', value:'Directeur général'},
				{text:'Directeur associé', value:'Directeur associé'},
				{text:'Directeur conseil', value:'Directeur conseil'},
				{text:'Consultant', value:'Consultant'},
				{text:'Office manager', value:'Office manager'},
			],
			allUtilisateurs: null,
			allClients: null,
			display: true,
			disabledButton: false,
		}
	},
	beforeCreate: function () {
		this.$nextTick(function () {
			this.utilisateurs();
			this.clients();
		})
	},
	methods: {
		utilisateurs() {
			Vue.http.get(
				'api/utilisateurs/',
			).then(response => {
				this.allUtilisateurs = _.orderBy(response.data.data, 'name')
				return this.allUtilisateurs
			}).then(allUtilisateurs => {
				footable.fooTable();
			})
		},
		clients() {
			Vue.http.get(
				'api/client',
			).then(response => {
				this.allClients = _.orderBy(response.data.data, 'name')
			})
		},
		modify(){
			this.disabled = 0;
			this.disabledButton = true;

		},
		cancel_modify() {
			this.disabled = 1;
			this.disabledButton = false;
		},
		submitForm() {
			if (this.createUser === false && this.updateUser === true && this.removeUser === true) {
				this.show(event); //show modal and if ok(@click=destroy) delete profil
			}

			if (this.createUser === false && this.updateUser === true && this.removeUser === false) {
				this.update(event);
			}

			if(this.createUser === true && this.updateUser === false && this.removeUser === false){
				this.create(event);
			}
		},
		create(event) {
			event.preventDefault()
			users.create(this, this.surname, this.name, this.type, this.email, this.password, this.role, this.solde)
			this.clear();
		},
		update(event) {
			event.preventDefault()
			users.update(this, this.utilisateur.id, this.surname, this.name, this.type, this.email, this.role, this.solde, this.password)
		},
		destroy() {
			event.preventDefault()
			this.$modal.hide('modal-confirm')
			users.destroy(this, this.utilisateur.id)
			this.clear()
		},
		showSuccessCreate() {
			this.$modal.show('dialog', {
				text: 'Le profil a bien été cree',
				class: 'modal-success',
				buttons: [
					{ title: 'Fermer' }
				]
			})
		},
		showSuccessUpdate() {
			this.$modal.show('dialog', {
				text: 'Le profil a bien été modifie',
				class: 'modal-success',
				buttons: [
					{ title: 'Fermer' }
				]
			})
		},
		showSuccessDelete() {
			this.$modal.show('dialog', {
				text: 'Le profil a bien été supprime',
				class: 'modal-success',
				buttons: [
					{ title: 'Fermer' }
				]
			})
		},
		showError() {
			this.$modal.show('dialog', {
				text: 'Il y a eu une erreur imposible de completer votre action',
				class: 'modal-error',
				buttons: [
					{ title: 'Fermer' }
				]
			})
		},
		show() {
			this.$modal.show('modal-confirm')
		},
		clear(){
			this.name = '';
			this.surname = '';
			this.type = '';
			this.email = '';
			this.password = '';
			this.role = 'veuillez choisir un role';
			this.temps = '';
			this.removeUser = false;
			this.updateUser = false;
			this.confirm = false;
			this.disabled = 0;
			this.display = false;
			this.disabledButton = true;
			this.utilisateur = null;
			this.createUser = true;
			this.solde = '';
		},
		fill(utilisateur,event) {
			this.name = utilisateur.user.name;
			this.surname = utilisateur.user.surename;
			this.email = utilisateur.user.email;
			this.type = utilisateur.user.type;
			this.role = utilisateur.role;
			this.temps = utilisateur.temps;
			this.utilisateur = utilisateur;
			this.removeUser = false;
			this.confirm = false;
      		active.active();
			this.display = false;
			this.disabledButton = false;
			this.updateUser = true;
			this.createUser = false;
			this.password = utilisateur.user.password;
			this.solde = utilisateur.solde;
		},
	}
}
</script>

<style lang="scss">
	 @import '../sass/app.scss';
</style>



// WEBPACK FOOTER //
// Users.vue?7906b0f0